import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
} from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import BlackWhiteSwitch from './BlackWhiteSwitch';

interface EditModalProps {
  open: boolean;
  onClose: () => void;
  onSave: (data: any) => void;
  initialData: Record<string, any>;
  excludeFields?: string[];
  readOnlyFields?: string[];
  title?: string;
}

const EditModal: React.FC<EditModalProps> = ({
  open,
  onClose,
  onSave,
  initialData,
  excludeFields = [],
  title = 'Edit',
  readOnlyFields = [],
}) => {
  const [formData, setFormData] = useState<Record<string, any>>({});

  useEffect(() => {
    setFormData(initialData);
  }, [initialData]);

  const handleChange = (field: string, value: string) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSave = () => {
    onSave(formData);
    onClose(); // Optional: Close dialog after saving
  };

  const capitalizeLabel = (label: string) => {
    const words = label.replace(/([A-Z])/g, ' $1'); // Insert space before capital letters
    return words.charAt(0).toUpperCase() + words.slice(1); // Capitalize first letter
  };
  

  return (
    <>
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md" className='roleModal'>
          <CancelIcon onClick={onClose} className='closeModal' />
          <DialogTitle>{title}</DialogTitle>
          <DialogContent dividers>
            <Box className="modalFormWrap">
              <Box component="form" className="modalForm">
                  {Object.entries(formData).map(([key, value]) => {
                      if (excludeFields.includes(key)) return null;
                      const isReadOnly = readOnlyFields?.includes(key);
                      return (
                          <>
                              <div className="form-control inputFieldWrap" key={key}>
                                  <label className="editModalLabel">{capitalizeLabel(key)}</label>
                                  <input
                                      type="text"
                                      className="inputField"
                                      value={value}
                                      onChange={(e) => handleChange(key, e.target.value)}
                                      readOnly={isReadOnly}
                                      style={isReadOnly ? { backgroundColor: '#f7fcff', cursor: 'not-allowed' } : {}}
                                  />
                              </div>
                          </>
                      );
                  })} 
              </Box>
              <Box display="flex" justifyContent="flex-end">
                  <Button onClick={handleSave} variant="contained" className='formBtn'>Save</Button>
              </Box>
            </Box>
      </DialogContent>
    </Dialog>
    </>
  );
};

export default EditModal;
    